// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AlertUtils } from '@shared/utils/Alert/AlertUtils';
import { AlertAction } from '@shared/utils/Alert/AlertConstants';
import CreateAlertActionSelectorTemplate from '@front/templates/CreateAlertActionSelectorTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class CreateAlertActionSelector extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'CreateAlertActionSelector';
    }
    oninit() {
        super.oninit();
        this.repopulate();
        this.observe('selectedItem', this.updateAlertAction);
        this.observe('value', this.updateAlertActionValue);
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    updateAlertAction(selectedItem) {
        if (!isNullOrUndefined(selectedItem)) {
            void this.set({ value: selectedItem.value });
        }
    }
    updateAlertActionValue(newV, oldV) {
        const items = this.get('items');
        if (!isValidArray(items)) {
            return;
        }
        for (let i = 0; i < items.length; i++) {
            if (items[i].value === newV) {
                void this.set({ selectedItem: items[i] });
                break;
            }
        }
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose.call(this);
    }
    repopulate() {
        const items = [];
        if (AlertUtils.AllowPlaceOrder()) {
            items.push({
                type: NewContextMenuItemType.Default,
                value: AlertAction.PLACE_ORDER_NOTIFY,
                text: 'screen.Alerts.Action.PlaceOrder'
            });
        }
        const notifyItem = {
            type: NewContextMenuItemType.Default,
            value: AlertAction.NOTIFY,
            text: 'screen.Alerts.Action.Notify'
        };
        items.push(notifyItem);
        void this.set({ items, selectedItem: notifyItem, visible: items.length > 1 });
    }
    localize() {
        void this.set({
            label: Resources.getResource('screen.Alerts.Label.Action')
        });
    }
}
ContainerControl.extendWith(CreateAlertActionSelector, {
    template: CreateAlertActionSelectorTemplate,
    data: function () {
        return {
            label: '',
            instrument: null,
            items: null,
            selectedItem: null,
            visible: true,
            width: 198
        };
    }
});
